module.exports = __webpack_public_path__ + "img/shopping-bag.adca3bfb.png";